import { loadStripe } from '@stripe/stripe-js';

import { getLangForTranslations } from './langUtil';

// Stripe adds these to our return_url, but only when the card needed a full redirect (some 3DS flows)
export const STRIPE_REDIRECT_STATUS_PARAM = 'redirect_status';
export const STRIPE_REDIRECT_STATUS_FAILED = 'failed';

// loadStripe injects the js.stripe.com script, it must only be called once per account
// Our connected accounts use direct charges, so the account id is mandatory to resolve the client secret
const stripePromises = {};

export const getStripePromise = (publishableKey, connectedAccountId) => {
  if (!publishableKey) return null;

  const cacheKey = `${publishableKey}|${connectedAccountId ?? ''}`;
  if (!stripePromises[cacheKey]) {
    stripePromises[cacheKey] = loadStripe(publishableKey, connectedAccountId ? { stripeAccount: connectedAccountId } : undefined);
  }
  return stripePromises[cacheKey];
};

export const getStripeElementsOptions = (clientSecret, brandColors) => ({
  clientSecret: clientSecret,
  locale: getLangForTranslations(),
  appearance: {
    theme: 'stripe',
    variables: {
      colorPrimary: brandColors.color_main,
      colorText: brandColors.color_font,
      colorBackground: brandColors.background_main,
      colorDanger: brandColors.color_alert_error_icon,
      fontFamily: `'InterVariable', sans-serif`,
      fontSizeBase: '0.9rem',
      borderRadius: '5px',
    },
    rules: {
      '.Input': { borderColor: brandColors.color_main, boxShadow: 'none' },
      '.Input:focus': { borderColor: brandColors.color_main, boxShadow: `0 0 0 1px ${brandColors.color_main}` },
      '.Label': { color: brandColors.color_main, fontSize: '0.8rem', marginBottom: '1px' },
    },
  },
});

// Stripe only collects what we do not already have in our own form
// When our address block is not required we let Stripe ask for the country/zip, it is needed for AVS
export const getStripePaymentElementOptions = hasBillingAddress => ({
  layout: 'tabs',
  fields: {
    billingDetails: {
      name: 'never',
      email: 'never',
      phone: 'never',
      address: hasBillingAddress ? 'never' : 'auto',
    },
  },
  // We keep the card form to the card only, Link would add its own signup fields
  wallets: { link: 'never' },
});
